var _path, _path2, _tspan, _tspan2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygonDoubleWrong(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12.419 19.869",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-128.32 -142.61)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.32,
    y: 142.61,
    width: 12.419,
    height: 12.419,
    rx: 1.8797,
    ry: 1.8797,
    fill: "#fff",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.9437 -4.7268)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m143.54 153.55h-6.3828",
    fill: "none",
    stroke: "#8895b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66146
  })), /*#__PURE__*/React.createElement("rect", {
    x: 141.38,
    y: 151.99,
    width: 4.5712,
    height: 3.104,
    rx: 1.552,
    ry: 1.552,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m137.99 153.04c-.28556-.80906-1.1678-1.236-1.9706-.95375-.80277.28229-1.2221 1.1669-.93646 1.976.28557.80905 1.1678 1.236 1.9706.95379.80282-.28231 1.2221-1.1669.9365-1.976z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 136.26698,
    y: 154.06006,
    fill: "#f9f9f9",
    fontFamily: "Figtree",
    fontSize: "1.4644px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.020592,
    style: {
      lineHeight: 1.3,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 136.26698,
    y: 154.06006,
    fill: "#f9f9f9",
    strokeWidth: 0.020592
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    x: 142.66107,
    y: 153.98538,
    fill: "#f9f9f9",
    fontFamily: "Figtree",
    fontSize: "1.4644px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.020592,
    style: {
      lineHeight: 1.3,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 142.66107,
    y: 153.98538,
    fill: "#f9f9f9",
    strokeWidth: 0.020592
  }, "2,3")))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4783 0 0 .4783 64.971 78.979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m145.44 174.58c2.7998 0 5.0695-2.2697 5.0695-5.0695 0-2.7998-2.2697-5.0695-5.0695-5.0695-2.7998 0-5.0695 2.2697-5.0695 5.0695 0 2.7998 2.2697 5.0695 5.0695 5.0695z",
    fill: "#d40000",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.304)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.87 158.78 3.1254-3.155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147 158.78-3.1254-3.155"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonDoubleWrong);
export default __webpack_public_path__ + "static/media/polygon_double_wrong.886db1e38a36b7e0ca182d1244571742.svg";
export { ForwardRef as ReactComponent };